module.exports = __webpack_public_path__ + "static/media/logo-blue.33a490df.svg";